import { recordWebPractice } from "@/lib/practice-client";
import type { DisplayTranscript, TypedTranscript } from "@/lib/typedTranscriptDisplay";
import { useEffect, useRef } from "react";

/** Credit accepted language contributions independently of transcript visibility. */
export function useTranscriptPracticeActivity(
  voice: readonly DisplayTranscript[],
  typed: readonly TypedTranscript[],
  countsAsLanguagePractice: boolean
) {
  const credited = useRef(new Set<string>());
  useEffect(() => {
    if (!countsAsLanguagePractice) return;
    for (const segment of voice) {
      if (
        segment.role !== "user" ||
        !segment.text?.trim() ||
        (segment.isFinal ?? segment.final) !== true
      )
        continue;
      const id = String(segment.id);
      if (credited.current.has(id)) continue;
      credited.current.add(id);
      void recordWebPractice(segment.firstReceivedTime || Date.now()).catch(() => {});
    }
  }, [countsAsLanguagePractice, voice]);

  useEffect(() => {
    if (!countsAsLanguagePractice) return;
    for (const message of typed) {
      if (message.pending || !message.text?.trim()) continue;
      const id = `typed:${message.id}`;
      if (credited.current.has(id)) continue;
      credited.current.add(id);
      void recordWebPractice(message.firstReceivedTime).catch(() => {});
    }
  }, [countsAsLanguagePractice, typed]);
}
